var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-3"},[_c('TabsVue',{attrs:{"tabs":_vm.tabs,"selected-tab":1}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }